export { renderSquircle, squircleObserver } from "./corner-smoothing-vanilla";
export { Squircle, squircle } from "./corner-smoothing-react";
//# sourceMappingURL=index.js.map